const windowShapes = {
  rearGlass: "M90 95 L135 92 L133 120 L85 122 Z",
  rearSideLeft: "M140 88 L205 85 L200 122 L135 122 Z",
  rearSideRight: "M210 85 L275 82 L267 122 L202 122 Z",
  frontSide: "M280 80 L355 77 L343 122 L270 122 Z",
  windshield: "M360 75 L420 80 L400 122 L346 122 Z",
  sunstrip: "M362 76 L418 81 L410 95 L360 92 Z",
  roof: "M170 70 L340 68 L320 78 L185 80 Z",
};

const bodyClass = "fill-[#eef2f7] stroke-white/45";
const activeFill = "#ef4444";
const inactiveFill = "rgba(255,255,255,0.11)";

const isShapeActive = (shapeKey, activeAreas) => {
  if (shapeKey === "roof") {
    return activeAreas.includes("full_vehicle_surround");
  }

  if (shapeKey === "rearGlass") {
    return activeAreas.includes("full_vehicle_surround");
  }

  if (shapeKey === "rearSideLeft" || shapeKey === "rearSideRight") {
    return activeAreas.includes("full_vehicle_surround");
  }

  if (shapeKey === "frontSide") {
    return activeAreas.includes("full_vehicle_surround") || activeAreas.includes("front_two_windows");
  }

  if (shapeKey === "windshield") {
    return activeAreas.includes("windshield");
  }

  if (shapeKey === "sunstrip") {
    return activeAreas.includes("sunstrip");
  }

  return false;
};

export const TintVehiclePreview = ({ activeAreas, className = "" }) => {
  return (
    <svg
      className={`sport-tint-car ${className}`.trim()}
      data-testid="tint-vehicle-preview-svg"
      fill="none"
      viewBox="0 0 500 240"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="car-body-gradient-modern" x1="60" x2="435" y1="75" y2="195" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFFFFF" />
          <stop offset="0.3" stopColor="#F1F5F9" />
          <stop offset="0.7" stopColor="#CBD5E1" />
          <stop offset="1" stopColor="#94A3B8" />
        </linearGradient>
        <linearGradient id="car-shadow-gradient-modern" x1="120" x2="400" y1="210" y2="210" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgba(0,0,0,0)" />
          <stop offset="0.5" stopColor="rgba(0,0,0,0.4)" />
          <stop offset="1" stopColor="rgba(0,0,0,0)" />
        </linearGradient>
        <linearGradient id="window-gloss-gradient-modern" x1="100" x2="390" y1="75" y2="130" gradientUnits="userSpaceOnUse">
          <stop stopColor="rgba(255,255,255,0.35)" />
          <stop offset="1" stopColor="rgba(255,255,255,0.05)" />
        </linearGradient>
        <linearGradient id="body-accent-gradient" x1="100" x2="400" y1="165" y2="165" gradientUnits="userSpaceOnUse">
          <stop stopColor="#475569" />
          <stop offset="0.5" stopColor="#64748b" />
          <stop offset="1" stopColor="#475569" />
        </linearGradient>
      </defs>

      {/* Enhanced shadow */}
      <ellipse cx="260" cy="210" fill="url(#car-shadow-gradient-modern)" rx="170" ry="20" opacity="0.5" />

      <g className="modern-car-shell">
        {/* Lower body / Underbody */}
        <path 
          d="M60 175H440C448 175 452 180 450 187L445 197H55L58 182C59 177 63 175 68 175H60Z" 
          fill="#94A3B8" 
          opacity="0.9" 
        />

        {/* Main car body - sleek sedan profile */}
        <path
          className="modern-car-body"
          d="M55 172 L85 168 L115 148 L145 105 C155 92 172 82 195 80 L325 78 C342 78 358 83 373 93 L415 115 C432 123 445 135 453 148 L465 172 H55Z"
          fill="url(#car-body-gradient-modern)"
          stroke="rgba(255,255,255,0.7)"
          strokeWidth="2.5"
        />

        {/* Body accent line */}
        <path 
          d="M120 165H410" 
          stroke="url(#body-accent-gradient)" 
          strokeLinecap="round" 
          strokeWidth="2.5" 
          opacity="0.6"
        />

        {/* Door lines */}
        <path d="M85 145L140 108" stroke="rgba(255,255,255,0.4)" strokeLinecap="round" strokeWidth="3" />
        <path d="M380 100L418 120" stroke="rgba(15,23,42,0.25)" strokeLinecap="round" strokeWidth="3" />

        {/* Window separator line */}
        <path d="M105 135H395" stroke="rgba(15,23,42,0.15)" strokeLinecap="round" strokeWidth="5" />

        {/* Window shapes with tint highlighting */}
        {Object.entries(windowShapes).map(([shapeKey, shapePath]) => {
          const isActive = isShapeActive(shapeKey, activeAreas);
          return (
            <path
              key={shapeKey}
              d={shapePath}
              data-testid={`tint-preview-shape-${shapeKey}`}
              fill={isActive ? activeFill : inactiveFill}
              stroke={isActive ? "rgba(255,255,255,0.95)" : "rgba(255,255,255,0.28)"}
              strokeWidth="2"
              opacity={isActive ? 0.95 : 0.9}
            />
          );
        })}

        {/* Window gloss reflection */}
        <path 
          d="M92 88L400 78" 
          stroke="url(#window-gloss-gradient-modern)" 
          strokeLinecap="round" 
          strokeWidth="6" 
          opacity="0.6"
        />

        {/* Body highlight line */}
        <path d="M125 172H405" stroke="#64748b" strokeLinecap="round" strokeWidth="3" opacity="0.7" />

        {/* Front wheel */}
        <g>
          <circle className="wheel-outer" cx="370" cy="180" fill="#1a1a1a" r="32" />
          <circle cx="370" cy="180" fill="#2d3748" r="20" />
          <circle cx="370" cy="180" fill="#4a5568" r="12" />
          <circle cx="370" cy="180" fill="#718096" r="4" />
        </g>

        {/* Rear wheel */}
        <g>
          <circle className="wheel-outer" cx="155" cy="180" fill="#1a1a1a" r="32" />
          <circle cx="155" cy="180" fill="#2d3748" r="20" />
          <circle cx="155" cy="180" fill="#4a5568" r="12" />
          <circle cx="155" cy="180" fill="#718096" r="4" />
        </g>

        {/* Wheel well shadows */}
        <ellipse cx="370" cy="175" rx="34" ry="8" fill="rgba(0,0,0,0.2)" />
        <ellipse cx="155" cy="175" rx="34" ry="8" fill="rgba(0,0,0,0.2)" />

        {/* Front bumper detail */}
        <path d="M70 170C78 156 90 146 108 140" stroke="rgba(255,255,255,0.5)" strokeLinecap="round" strokeWidth="3" />

        {/* Rear detail */}
        <path d="M408 125C422 132 436 142 448 152" stroke="rgba(255,255,255,0.35)" strokeLinecap="round" strokeWidth="3" />

        {/* Hood/Trunk lines */}
        <path d="M120 155L115 145" stroke="rgba(255,255,255,0.3)" strokeLinecap="round" strokeWidth="2" />
        <path d="M405 145L400 135" stroke="rgba(255,255,255,0.25)" strokeLinecap="round" strokeWidth="2" />
      </g>
    </svg>
  );
};